import type { Route, RouteRepository } from './RepositoryInterfaces.js';

export class InMemoryRouteRepository implements RouteRepository {
  private routes: Map<string, Route> = new Map();

  async findAll(): Promise<Route[]> {
    return Array.from(this.routes.values());
  }

  async findById(id: string): Promise<Route | undefined> {
    return this.routes.get(id);
  }

  async findByProjectId(projectId: string): Promise<Route[]> {
    return (await this.findAll()).filter((r) => r.projectId === projectId);
  }

  async save(route: Route): Promise<Route> {
    this.routes.set(route.id, route);
    return route;
  }

  async delete(id: string): Promise<void> {
    this.routes.delete(id);
  }

  seed(routes: Route[]): void {
    routes.forEach((r) => this.routes.set(r.id, r));
  }
}

export const createInMemoryRouteRepository = (): InMemoryRouteRepository => new InMemoryRouteRepository();
